<template>
  <div>
    <Head v-if="status" title="Success Validation" />
    <Head v-else title="Failure Validation" />
    <h1 v-if="status" class="mb-8 text-3xl font-bold">Success</h1>
    <h1 v-else class="mb-8 text-3xl font-bold">Failure</h1>
    <div class="flex items-center justify-between mb-6"></div>
    <div v-if="status" class="bg-white">
      <div
        class="flex items-center justify-between mb-8 w-full max-w-3xl bg-green-500 rounded"
      >
        <div class="flex items-center">
          <svg
            class="flex-shrink-0 ml-4 mr-2 w-4 h-4 fill-white"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <polygon points="0 11 2 9 7 14 18 3 20 5 7 18" />
          </svg>
          <div class="py-4 text-white text-sm font-medium">{{ message }}</div>
        </div>
      </div>
      <div class="flex items-center justify-between mb-8 w-full max-w-3xl rounded">
        <div class="flex items-center">
          <span class="flex w-full rounded-md shadow-sm sm:ml-0 sm:w-auto">
            <a
              v-if="
                (user.per_user_permissions.includes('view_invoices') ||
                  user.group_permissions.includes('view_invoices') ||
                  user.role === 'admin') &&
                invoice.taxilla_status == 'completed'
              "
              class="btn btn-orange text-xs cursor-pointer ml-1 mr-1"
              :href="`/download-taxilla-pdf-invoices/${invoice.id}`"
              target="__blank"
              title="Download"
            >
              <span>View Invoice</span>
            </a>
          </span>
          <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
            <Link
              type="button"
              class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
              href="/pick-up-queue"
            >
              Back
            </Link>
          </span>
        </div>
      </div>
    </div>
    <div v-else class="bg-white">
      <div
        class="flex items-center justify-between mb-8 w-full max-w-3xl bg-red-500 rounded"
      >
        <div class="flex items-center">
          <svg
            class="flex-shrink-0 ml-4 mr-2 w-4 h-4 fill-white"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path
              d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm1.41-1.41A8 8 0 1 0 15.66 4.34 8 8 0 0 0 4.34 15.66zm9.9-8.49L11.41 10l2.83 2.83-1.41 1.41L10 11.41l-2.83 2.83-1.41-1.41L8.59 10 5.76 7.17l1.41-1.41L10 8.59l2.83-2.83 1.41 1.41z"
            />
          </svg>
          <div class="py-4 text-white text-sm font-medium">{{ message }}</div>
        </div>
      </div>
      <div class="flex items-center justify-between mb-8 w-full max-w-3xl rounded">
        <div class="flex items-center">
          <span class="flex w-full rounded-md shadow-sm sm:ml-0 sm:w-auto">
            <button
              v-if="
                (user.per_user_permissions.includes('view_invoices') ||
                  user.group_permissions.includes('view_invoices') ||
                  user.role === 'admin') &&
                taxillaStatus != 'completed'
              "
              type="button"
              class="btn btn-orange text-xs cursor-pointer ml-1 mr-1"
              @click="initiateTaxilla(invoice)"
            >
              Retry
            </button>
          </span>
          <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
            <Link
              type="button"
              class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
              href="/pick-up-queue"
            >
              Back
            </Link>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Head, Link } from "@inertiajs/inertia-vue3";
import Icon from "@/Shared/Icon";
import Layout from "@/Shared/Layout";

export default {
  components: {
    Head,
    Icon,
    Link,
  },
  layout: Layout,
  props: {
    message: String,
    invoice: Object,
    status: Boolean,
  },
  data() {
    return {
      formTaxillaData: {
        id: null,
      },
    };
  },
  computed: {
    user() {
      return this.$inertia.page.props.auth.user;
    },
  },
  methods: {
    initiateTaxilla() {
      this.formTaxillaData._method = "post";
      this.$inertia.post(
        `/push-taxilla-invoices/${this.invoice.id}`,
        this.formTaxillaData
      );
    },
  },
};
</script>
